"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateRule = evaluateRule;
function evaluateRule(rule, context) {
    if (rule) {
        if ('value' in rule) {
            return rule.value;
        }
        else {
            const operator = operators[rule.op];
            if (operator) {
                return operator(rule.params, context);
            }
            else {
                throw new Error(`Invalid rule, unknown op ${rule.op}.`);
            }
        }
    }
    else {
        return undefined;
    }
}
const operators = {
    get: operator('string', 1, ([field], context) => (field != null ? context === null || context === void 0 ? void 0 : context[field] : undefined)),
    and: operator('boolean', 2, ([value1, value2]) => !!(value1 && value2)),
    or: operator('boolean', 2, ([value1, value2]) => !!(value1 || value2)),
    not: operator('boolean', 1, ([value]) => !value),
    eq: operator('unknown', 2, ([value1, value2]) => value1 === value2),
    gt: operator('number', 2, ([value1, value2]) => (value1 != null && value2 != null ? value1 > value2 : undefined)),
    gte: operator('number', 2, ([value1, value2]) => (value1 != null && value2 != null ? value1 >= value2 : undefined)),
    lt: operator('number', 2, ([value1, value2]) => (value1 != null && value2 != null ? value1 < value2 : undefined)),
    lte: operator('number', 2, ([value1, value2]) => (value1 != null && value2 != null ? value1 <= value2 : undefined)),
    beginsWith: operator('string', 2, ([string, searchSubstring]) => string != null && searchSubstring != null ? string.startsWith(searchSubstring) : undefined),
    endsWith: operator('string', 2, ([string, searchSubstring]) => string != null && searchSubstring != null ? string.endsWith(searchSubstring) : undefined),
    contains: operator('string', 2, ([string, searchSubstring]) => string != null && searchSubstring != null ? string.includes(searchSubstring) : undefined),
    matches: operator('string', 2, ([string, searchPattern]) => string != null && searchPattern != null ? new RegExp(searchPattern).test(string) : undefined),
    in: operator('unknown', 2, ([value, array]) => {
        if (value != null) {
            if (Array.isArray(array)) {
                return array.includes(value);
            }
            else {
                throw new Error(`Rule evaluation failed, expected array param, got ${typeof array} param.`);
            }
        }
        else {
            return false;
        }
    }),
    exists: operator('unknown', 1, ([value]) => value != null),
};
function operator(paramType, paramCount, impl) {
    return (params, context) => {
        if (params.length !== paramCount) {
            throw new Error(`Invalid rule, expected ${paramCount} params, got ${params.length} params.`);
        }
        const values = [];
        for (let i = 0; i < paramCount; i++) {
            const value = evaluateRule(params[i], context);
            if (value != null && paramType !== 'unknown' && typeof value !== paramType) {
                throw new Error(`Rule evaluation failed, expected ${paramType} param, got ${typeof value} param.`);
            }
            values.push(value != null ? value : undefined);
        }
        return impl(values, context);
    };
}
